import Parser from 'html-react-parser';
import './styles.scss';
import l from '../../../../lang';
import { getLanguage, openNewTabAndFocus } from '../../../../utils';
import ButtonLink from '../../../common/button-link';
import { Urls } from '../../../../config/urls';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import { useMediaQuery } from '@mui/material';
import { segmentIntegrationsWooCommerceInstall, segmentIntegrationsWooCommercePageLinkDocs } from '../../../../utils/analytics';

const AddToWooCommerce = () => {
  const isTabletMobile = useMediaQuery('(max-width:768px)');

  const getUrl = (lang: string) => {
    switch (lang) {
      case 'es':
        return Urls.docs.woocommerceIntegration.es;
      case 'en':
        return Urls.docs.woocommerceIntegration.en;
      default:
        return Urls.docs.woocommerceIntegration.en;
    }
  };

  return (
    <div className="add-to-woo-commerce">
      <p>{l('paymentIntegration.woocommerce.desc')}</p>
      <p>
        <ButtonLink
          text={l('paymentIntegration.woocommerce.link')}
          onClick={() => {
            segmentIntegrationsWooCommercePageLinkDocs();
            openNewTabAndFocus(getUrl(getLanguage()))
          }}
        />
        <span> {Parser(l('paymentIntegration.woocommerce.desc2'))}</span>
      </p>
      <div className="add-to-magento__btn">
        <ButtonCustom
          text={l('paymentIntegration.woocommerce.add')}
          variant="contained"
          size={`${isTabletMobile ? 'full-square' : 'square'}`}
          onClick={() => {
            segmentIntegrationsWooCommerceInstall();
            openNewTabAndFocus(Urls.woocommercePlugin)
          }}
        />
      </div>
    </div>
  );
};

export default AddToWooCommerce;
